export enum BiometricsModeEnum {
  SignIn = 'sign-in',
  SignUp = 'sign-up',
}

/**
 * Key values used to store persistent data for future Biometrics sessions
 */
export enum BiometricsStorageKeyEnum {
  /**
   * I don't remember why we have to store the email
   * that the user used for authenticating.
   */
  AuthEmails = 'authEmails',
}